import React, { useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { FaUserAlt } from 'react-icons/fa';

import jwt_decode from 'jwt-decode';

import { BoxUser, Container } from './styles';

import { signOut } from '~/store/modules/auth/actions';

import Link from './typeLink';

const NavBar = () => {
  const currentUrl = window.location.pathname;
  const dispath = useDispatch();
  const linhasDeCuidado = useSelector(state => state.careLines.careLinesActive);
  const { token, roles } = useSelector(state => state.auth);

  const ROLE_ADMIN = roles?.includes('ROLE_ADMIN');
  const ROLE_MANAGER = roles?.includes('ROLE_MANAGER');
  const ROLE_USER = roles?.includes('ROLE_USER');

  const decodedToken = jwt_decode(token.split(' ')[1]);

  const { name } = decodedToken;

  const userName = useMemo(() => {
    const [nameOfUser] = name?.split(' ');

    return nameOfUser;
  }, [name]);

  const userRole = useMemo(() => {
    const _role =
      (ROLE_ADMIN && 'Administrador') ||
      (ROLE_MANAGER && 'Gestor') ||
      (ROLE_USER && 'Usuário');

    return _role;
  }, [ROLE_ADMIN, ROLE_MANAGER, ROLE_USER]);

  const NavLinhasDeCuidado = () => {
    return (
      <>
        {linhasDeCuidado &&
          linhasDeCuidado
            .filter(
              linha =>
                linha.ativo &&
                linha.nomeIdentificador !== 'indicadores_painel_geral'
            )
            .map(({ nomeIdentificador }) => {
              const nomeIndicador =
                (nomeIdentificador === 'acidente_vascular_cerebral' && 'AVC') ||
                (nomeIdentificador === 'artropatia_de_quadril' && 'Quadril') ||
                (nomeIdentificador === 'cancer_de_prostata' &&
                  'Câncer de Próstata') ||
                (nomeIdentificador === 'cancer_de_mama' && 'Câncer de Mama') ||
                (nomeIdentificador === 'sepse_e_choque_septico' && 'Sepse') ||
                (nomeIdentificador === 'sindrome_coronariana_aguda' && 'SCA');

              return (
                <li key={nomeIdentificador}>
                  <Link to={`/linhas-de-cuidado/${nomeIdentificador}`}>
                    {nomeIndicador || nomeIdentificador}
                  </Link>
                </li>
              );
            })}
      </>
    );
  };

  const Logout = () => {
    dispath(signOut());
  };

  return (
    <Container>
      <nav className="menu">
        <ul>
          {!ROLE_USER && (
            <li
              className={
                [
                  '/indicadores-gerais',
                  '/administrador/perfil-geral-dos-hospitais',
                ].indexOf(currentUrl) >= 0
                  ? 'active'
                  : ''
              }
            >
              <Link to="/indicadores-gerais">Resultados</Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/indicadores-gerais">Painel de Indicadores</Link>
                </li>
                <li>
                  <Link to="/#">Estratificações</Link>
                  <ul className="sub-estratificacoes">
                    <li>
                      <Link to="/estratificacao/clinicas_geral">Geral</Link>
                    </li>
                    <li>
                      <Link to="/estratificacao/clinicas_avc">AVC</Link>
                    </li>
                    <li>
                      <Link to="/estratificacao/clinicas_sca">SCA</Link>
                    </li>
                    <li>
                      <Link to="/estratificacao/clinicas_sepse">Sepse</Link>
                    </li>
                    <li>
                      <Link to="/estratificacao/clinicas_quadril">Quadril</Link>
                    </li>
                    <li>
                      <Link to="/estratificacao/clinicas_prostata">
                        Câncer de Próstata
                      </Link>
                    </li>
                    <li>
                      <Link to="/estratificacao/clinicas_mama">
                        Câncer de Mama
                      </Link>
                    </li>
                  </ul>
                </li>
                {!ROLE_MANAGER && (
                  <li>
                    <Link to="/administrador/perfil-geral-dos-hospitais">
                      Perfil geral dos hospitais
                    </Link>
                  </li>
                )}
              </ul>
            </li>
          )}

          {!ROLE_ADMIN && (
            <>
              <li
                className={
                  [
                    '/enviar-indicadores-gerais',
                    '/linhas-de-cuidado/acidente_vascular_cerebral',
                    '/linhas-de-cuidado/artropatia_de_quadril',
                    '/linhas-de-cuidado/cancer_de_mama',
                    '/linhas-de-cuidado/cancer_de_prostata',
                    '/linhas-de-cuidado/sepse_e_choque_septico',
                    '/linhas-de-cuidado/sindrome_coronariana_aguda',
                  ].indexOf(currentUrl) >= 0
                    ? 'active'
                    : ''
                }
              >
                <Link to="#">Submissão</Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/enviar-indicadores-gerais">Painel Geral</Link>
                  </li>

                  <li>
                    <Link to="#">Linhas de Cuidado</Link>
                    <ul className="sub-linhas-de-cuidado">
                      <NavLinhasDeCuidado />
                    </ul>
                  </li>
                </ul>
              </li>
            </>
          )}

          {!ROLE_USER && (
            <li>
              <Link to="#">Dados</Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/dados/completude">Completude</Link>
                </li>
                <li>
                  <Link to="/dados/download-de-dados">Download</Link>
                </li>
              </ul>
            </li>
          )}

          {ROLE_ADMIN && (
            <>
              <li>
                <Link to="#">Cadastro</Link>
                <ul className="sub-menu">
                  <li
                    className={
                      currentUrl === '/cadastro/instituicoes-participantes'
                        ? 'active'
                        : ''
                    }
                  >
                    <Link to="/administrador/instituicoes-participantes">
                      Instituições participantes
                    </Link>
                  </li>
                  <li
                    className={
                      currentUrl === '/administrador/usuarios-do-sistema'
                        ? 'active'
                        : ''
                    }
                  >
                    <Link to="/administrador/usuarios-do-sistema">
                      Usuários do sistema
                    </Link>
                  </li>
                </ul>
              </li>
            </>
          )}

          {!ROLE_ADMIN && (
            <li
              className={
                currentUrl.includes('administrador/in') ? 'active' : ''
              }
            >
              <Link to="#">Dados Institucionais</Link>
              <ul className="sub-menu">
                <li>
                  <li>
                    <Link to="/administrador/informacoes-institucionais">
                      Informações Institucionais
                    </Link>
                  </li>
                  <li>
                    <Link to="/administrador/indicadores-competencias">
                      Indicadores
                    </Link>
                  </li>
                  {ROLE_MANAGER && (
                    <li>
                      <Link to="/administrador/perfil-do-hospital">
                        Formulário de Perfil
                      </Link>
                    </li>
                  )}
                </li>
              </ul>
            </li>
          )}

          {ROLE_MANAGER && (
            <li
              className={
                currentUrl.includes('usuarios-do-sistema') ? 'active' : ''
              }
            >
              <Link to="/administrador/usuarios-do-sistema">Usuários</Link>
            </li>
          )}

          <li className={currentUrl.includes('registros') ? 'active' : ''}>
            <Link to="#">Registro de Log</Link>
            <ul className="sub-menu">
              <li>
                <Link to="/registros-de-operacoes">Registros de Operações</Link>
              </li>
              <li>
                <Link to="/registros-de-operacoes/registro-de-acessos">
                  Registros de Acessos
                </Link>
              </li>
            </ul>
          </li>

          {ROLE_ADMIN ? (
            <li className={currentUrl === '/ajuda' ? 'active' : ''}>
              <Link to="/ajuda">Suporte</Link>
            </li>
          ) : (
            <li className={currentUrl === '/area-de-suporte' ? 'active' : ''}>
              <Link to="/area-de-suporte">Suporte</Link>
            </li>
          )}
        </ul>

        {/*
            Account navbar
        */}
        <ul>
          <li
            className={
              currentUrl === '/administrador/minha-conta'
                ? `active sair-${roles[0]}`
                : `sair-${roles[0]}`
            }
            style={{ position: 'relative' }}
          >
            <Link>
              <BoxUser>
                <div>
                  <span>{userRole}</span>
                  <strong>{userName || ''}</strong>
                </div>

                <FaUserAlt size="13" />
              </BoxUser>
            </Link>
            <ul
              className="sub-menu account-navbar"
              style={{ position: 'absolute', right: 0 }}
            >
              <li>
                <Link to="/administrador/minha-conta">Minha Conta</Link>
              </li>

              <li onClick={() => Logout()}>
                <Link>Sair</Link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </Container>
  );
};

export default NavBar;
export { NavBar };
